export default __webpack_public_path__ + "static/media/map-icon-white.356bcbaa.svg";